<template>
  <v-card color="rgba(255, 255, 255, 0.9)">
    <v-card-text>
      <form @submit.prevent="submit">
        <v-row>
          <v-col class="col-12 col-sm-12 col-md-4">
            <v-select
              v-model="pointSell"
              :items="pointSells"
              return-object
              :error-messages="errors"
              label="Půjčovna"
              item-text="title"
              prepend-icon="mdi-map-marker"
              required
            ></v-select>
          </v-col>
          <v-col class="col-12 col-sm-6 col-md-4">
            <v-menu
              v-model="checkInDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Zapůjčit od (8:00)"
                  :value="computedDateFormattedMomentjs"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="checkInDate"
                locale="cs-CZ"
                :min="checkInMinDate"
                :max="checkInMaxDate"
                @input="checkInDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col class="col-12 col-sm-6 col-md-4">
            <v-menu
              v-model="checkOutDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Zapůjčit do (18:00)"
                  :value="computedDateCheckOutFormattedMomentjs"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="checkOutDate"
                locale="cs-CZ"
                :min="checkOutMinDate"
                :max="checkOutMaxDate"
                @input="checkOutDateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col xs="12" sm="12" md="4">
            <v-btn block color="primary" @click="goToSearch">
              Zobrazit nabídku
            </v-btn>
          </v-col>
        </v-row>
        <v-row> </v-row>
      </form>
    </v-card-text>
  </v-card>
</template>

<style lang="css"></style>

<script>
import moment from "moment";

export default {
  name: "RentSearchToolbar",

  data: () => ({
    errors: null,
    checkInDateMenu: false,
    checkOutDateMenu: false
  }),

  computed: {
    computedDateFormattedMomentjs() {
      return this.checkInDate
        ? moment(this.checkInDate).format("D. M. YYYY")
        : "";
    },

    computedDateCheckOutFormattedMomentjs() {
      return this.checkOutDate
        ? moment(this.checkOutDate).format("D. M. YYYY")
        : "";
    },

    locations() {
      return this.$store.state.locations;
    },

    pointSells() {
      return this.$store.state.pointSells;
    },

    location: {
      get() {
        return this.$store.state.location;
      },

      set(value) {
        this.$store.commit("doSetLocation", value);
      }
    },

    pointSell: {
      get() {
        return this.$store.state.pointSell;
      },

      set(value) {
        this.$store.commit("doSetPointSell", value);
      }
    },

    checkInDate: {
      get() {
        return this.$store.state.checkInDate;
      },

      set(value) {
        if (moment(value) > moment(this.checkOutDate)) {
          this.checkOutDate = value;
        }
        this.$store.commit("doSetCheckInDate", value);
      }
    },

    checkOutDate: {
      get() {
        return this.$store.state.checkOutDate;
      },

      set(value) {
        if (moment(value) < moment(this.checkInDate)) {
          this.checkInDate = value;
        }
        this.$store.commit("doSetCheckOutDate", value);
      }
    },

    checkInMinDate() {
      if (this.$store.state.mobConfig != null) {
        return moment()
          .add(this.$store.state.mobConfig.rentBookingOffset, "hours")
          .format("YYYY-MM-DD");
      } else {
        return this.checkInDate;
      }
    },

    checkOutMinDate() {
      if (this.$store.state.mobConfig != null) {
        return moment()
          .add(this.$store.state.mobConfig.rentBookingOffset, "hours")
          .format("YYYY-MM-DD");
      } else {
        return this.checkOutDate;
      }
    },

    checkInMaxDate() {
      return moment()
        .add(90, "days")
        .format("YYYY-MM-DD");
    },

    checkOutMaxDate() {
      return moment()
        .add(90, "days")
        .format("YYYY-MM-DD");
    }
  },

  methods: {
    goToSearch() {
      this.$router.push({
        name: "rent-search"
      });
    }
  }
};
</script>
